import * as R from 'ramda';
import memoize from 'memoize-one';
import { getTerm, getConstraints } from './router';

const getSearch = R.prop('search');

export const getRows = memoize((state) => R.prop('rows', getSearch(state)));

export const getHasNoSearchParams = memoize((state) => {
  const term = getTerm(state);
  const constraints = getConstraints(state);

  const isTermEmpty = R.anyPass([R.isEmpty, R.isNil])(term);
  const areConstraintsEmpty = R.anyPass([R.isEmpty, R.isNil])(constraints);

  return isTermEmpty && areConstraintsEmpty;
});
